import { type GetHookResponse } from '../hooks'
import { locationScorecardKey } from '../keys'
import { useTantalimQuery } from '../query'
import { DAY, HOUR, type LocationScorecardInput, type LocationScorecardSuccess } from '@terros/common'

export function useLocationScorecard(
  input: LocationScorecardInput,
  enabled = true
): GetHookResponse<LocationScorecardSuccess> {
  return useTantalimQuery<LocationScorecardInput, LocationScorecardSuccess, LocationScorecardSuccess>({
    url: '/location/scorecard',
    queryKey: locationScorecardKey(input),
    input,
    convertResponse: (data) => data,
    options: {
      enabled,
      gcTime: DAY,
      staleTime: HOUR,
    },
  })
}
